import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PointsIcon } from "src/assets/Icons";
import { DiscountsItem } from "src/store/slices/item/subitems/discounts.types";
import { formatNumber } from "src/utility";
import DiscountsRedeem from "../DiscountsRedeem/DiscountsRedeem";

type Props = {
  data: DiscountsItem | undefined;
  imageUrl: string | undefined;
  itemCode: string;
};

const DiscountRedeemBar: FC<Props> = ({ data, imageUrl, itemCode }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-4 md:gap-6">
      <div className="flex flex-col">
        <span className="text-font-subtle text-xs">{t("Discounts.youWillSpend")}</span>
        <div className="text-font-active flex items-center gap-2 text-lg font-semibold md:text-xl">
          <div className="text-secondary-60">
            <PointsIcon />
          </div>
          {formatNumber(data?.points ?? 0)} {t("Discounts.points")}
        </div>
      </div>
      <div className="w-40 shrink-0 md:w-64">
        <DiscountsRedeem data={data} imageUrl={imageUrl} itemCode={itemCode} />
      </div>
    </div>
  );
};

export default DiscountRedeemBar;
